import type { Geofence, ThemeClasses } from "../types";
import { GeofenceGridCard } from "./GeofenceGridCard";
import { GeofenceListRow } from "./GeofenceListRow";
import { DENSE_LIST } from "../../../../shared";

interface GeofenceListProps {
  geofences: Geofence[];
  loading: boolean;
  selectedView: "grid" | "list";
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  onEdit: (geofence: Geofence) => void;
  onViewMap: (geofence: Geofence) => void;
  onDelete?: (geofence: Geofence) => void;
}

const isYardGeofence = (geofence: Geofence) =>
  geofence.type === "truck_yard" || !!(geofence as any).truck_yard_id;

export function GeofenceList({
  geofences,
  loading,
  selectedView,
  themeClasses,
  isDarkMode,
  onEdit,
  onViewMap,
  onDelete,
}: GeofenceListProps) {
  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  if (geofences.length === 0) {
    return (
      <div
        className={`text-center h-full text-lg flex items-center justify-center ${themeClasses.textSecondary}`}
      >
        No hay geocercas
      </div>
    );
  }

  if (selectedView === "grid") {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {geofences.map((geofence) => (
          <GeofenceGridCard
            key={geofence.id}
            geofence={geofence}
            themeClasses={themeClasses}
            isDarkMode={isDarkMode}
            onEdit={onEdit}
            onViewMap={onViewMap}
            onDelete={isYardGeofence(geofence) ? undefined : onDelete}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={DENSE_LIST}>
      {geofences.map((geofence) => (
        <GeofenceListRow
          key={geofence.id}
          geofence={geofence}
          themeClasses={themeClasses}
          isDarkMode={isDarkMode}
          onEdit={onEdit}
          onViewMap={onViewMap}
          onDelete={isYardGeofence(geofence) ? undefined : onDelete}
        />
      ))}
    </div>
  );
}
